import axios from "../http";
let module = "/sysRolePermission";
function rolePermission(id){
	return axios.get(module + '/' + id);
}
export default {
	rolePermission
}